module.exports = __webpack_public_path__ + "img/brilliant_spaces_logo.994f094f.svg";